import { Accordion, AccordionDetails, Typography } from '@fox/atoms';
import { SwiftFoxOrganisationDetails, SwiftFoxPersonDetails } from '../../membership-form-template/contracts';
import { CustomField } from '../../membership-form-template/fields';
import { ResponsiveGrid } from './profile-style-components';

interface CustomFieldsProps {
	isEditing: boolean;
	values: SwiftFoxPersonDetails | SwiftFoxOrganisationDetails;
	setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
}

export function CustomFields({ values, setFieldValue, isEditing }: CustomFieldsProps) {
	const handleChange = (customFieldId: string, value: unknown) => {
		const customFieldValues = [...values['customFields']];
		const customFieldToEdit = customFieldValues.find(f => f.customFieldId === customFieldId);
		if (customFieldToEdit) {
			customFieldToEdit.value = value;
		}
		setFieldValue('customFields', customFieldValues);
	};
	return (
		<Accordion
			title={
				<Typography variant="h5" component="h3">
					{isEditing ? 'Edit Additional details' : 'Additional details'}
				</Typography>
			}
		>
			<AccordionDetails>
				<ResponsiveGrid>
					{values?.customFields?.map(custom => {
						return (
							<CustomField key={custom.customFieldId} customField={custom} onChange={handleChange} isEditing={isEditing} />
						);
					})}
				</ResponsiveGrid>
			</AccordionDetails>
		</Accordion>
	);
}
